import gql from 'graphql-tag';

export default gql`
    query GetRecipientDetails($jobId: Int, $notificationType: String) {
        getRecipientDetails(jobId: $jobId, notificationType: $notificationType) {
            recipientDetails {
                id
                userId
                name
                alertType
                isExternal
                email
            }
            regionEmail
        }
    }
`;
